import { ThemeConfig } from './theme-config';


export const PWC_THEME: ThemeConfig = {
  themeName: 'PWC',
  mainColors: {
    primaryColor: '#ff9514',
    accentColor: '#9b5713',
    warnColor: '#910000'
  },
  lddModules: {
    main: {
      textColor: 'white',
      backgroundColor: '#f51d45',
      backgroundImage: 'https://i.ytimg.com/vi/Unzc731iCUY/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDWCFXZmPjXXyCwWrDAcho__oVaOA',
    },
    resources: {
      textColor: 'white',
      backgroundColor: '#f51d45',
      backgroundImage: 'https://i.ytimg.com/vi/Unzc731iCUY/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDWCFXZmPjXXyCwWrDAcho__oVaOA',
    },
    faq: {
      textColor: 'white',
      backgroundColor: '#f51d45',
      backgroundImage: 'https://i.ytimg.com/vi/Unzc731iCUY/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDWCFXZmPjXXyCwWrDAcho__oVaOA',
    }
  },
  footerText: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.' +
    'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
  components: {
    navbarPrimary: {
      backgroundColor: '#ff9514',
      textColor: '#ffffff',
    },
    navbarSecondary: {
      backgroundColor: '#ffdfb9',
      textColor: '#fff',
    },
    toolbar: {
      backgroundColor: '#ffdfb9',
      textColor: '#000000',
    },
    avatarBackground: {
      backgroundColor: '#00ff00',
      textColor: '#000',
    }
  },
  images: {
    errorBackground: '/assets/images/backgrounds/ct-login-bg.jpg',
    favIcon: 'favicon.ico',
    menuLogo: '/assets/images/logos/pwc_white.png',
  },
  darkTheme: false,
};

export const DEFAULT_THEME: ThemeConfig = {
  themeName: 'Orange',
  mainColors: {
    primaryColor: '#ff9514',
    accentColor: '#9b5713',
    warnColor: '#910000'
  },
  lddModules: {
    main: {
      textColor: 'white',
      backgroundColor: '#f51d45',
      backgroundImage: 'https://i.ytimg.com/vi/Unzc731iCUY/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDWCFXZmPjXXyCwWrDAcho__oVaOA',
    },
    resources: {
      textColor: 'white',
      backgroundColor: '#f51d45',
      backgroundImage: 'https://i.ytimg.com/vi/Unzc731iCUY/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDWCFXZmPjXXyCwWrDAcho__oVaOA',
    }
  },
  footerText: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.' +
    'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
  components: {
    navbarPrimary: {
      backgroundColor: '#ff9514',
      textColor: '#ffffff',
    },
    navbarSecondary: {
      backgroundColor: '#ffdfb9',
      textColor: '#fff',
    },
    toolbar: {
      backgroundColor: '#ffdfb9',
      textColor: '#000000',
    },
    avatarBackground: {
      backgroundColor: '#00ff00',
      textColor: '#000',
    }
  },
  images: {
    errorBackground: '/assets/images/backgrounds/ct-login-bg.jpg',
    favIcon: 'favicon.ico',
    menuLogo: '/assets/images/logos/pwc_white.png',
  },
  darkTheme: false,
};

export const BLUE_THEME: Partial<ThemeConfig> = {
  themeName: 'Blue',
  mainColors: {
    primaryColor: '#1d40f5',
    accentColor: '#20139b',
    warnColor: '#910000'
  },
  components: {
    navbarPrimary: {
      backgroundColor: '#1d40f5',
      textColor: '#ffffff',
    },
    navbarSecondary: {
      // label: 'Secondary Nav Bar',
      // colors: {
      backgroundColor: '#bbc5fa',
      textColor: '#fff',
      // }
    },
    toolbar: {
      // label: 'Toolbar',
      // colors: {
      backgroundColor: '#bbc5fa',
      textColor: '#fff',
      // }
    },
    avatarBackground: {
      backgroundColor: '#00ff00',
      textColor: '#000',
    }
  },
  darkTheme: false,
};

export const RED_THEME: Partial<ThemeConfig> = {
  themeName: 'Red',
  mainColors: {
    primaryColor: '#f51d45',
    accentColor: '#9b1313',
    warnColor: '#910000'
  },
  components: {
    navbarPrimary: {
      backgroundColor: '#f51d45',
      textColor: '#ffffff',
    },
    navbarSecondary: {
      // label: 'Secondary Nav Bar',
      // colors: {
      backgroundColor: '#f8bcc8',
      textColor: '#fff',
      // }
    },
    toolbar: {
      // label: 'Toolbar',
      // colors: {
      backgroundColor: '#f8bcc8',
      textColor: '#fff',
      // }
    },
    avatarBackground: {
      backgroundColor: '#00ff00',
      textColor: '#000',
    }
  },
  darkTheme: false,
};
